import { APP_SETTING_TOGGLE_JS_EDITOR_MODAL } from './constants';

export function toggleJsEditorModal() {
  return {
    type: APP_SETTING_TOGGLE_JS_EDITOR_MODAL,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_TOGGLE_JS_EDITOR_MODAL:
      return {
        ...state,
        isOpenJsEditorModal: !state.isOpenJsEditorModal,
      };

    default:
      return state;
  }
}
